import {useNavigate, useRoutes, Navigate} from "react-router-dom";
import HomePage from "./components/home/HomePage";
import SurveySlackIndex from "./components/survey/survey-index/survey-slack-index";
import AssignUsers from "./components/Subscriptions/AssignUsers";
import DisplaySurvey from "./components/DisplaySurvey";
import ResponsesReport from "./components/PBI/ResponsesReport";
import SurveyCreate from "./components/survey/survey-create/survey-create"
// import Billing from "./components/billing/billing-index"
import {useTranslation} from "react-i18next";
import { ChartsMain } from "./charts/components/ChartsMain";
import { ChartRedirect } from "./charts/components/ChartRedirect";
import Overview from "./charts/pages/Overview";
import QuestionsData from "./charts/pages/QuestionsData";
import ComparativeInformation from "./charts/pages/ComparativeInformation";
import HomePageTest from "./components/home/HomePageTest";
import ChatTest from "./components/live-api/chat-test";

const AppRouting = () => {
    const {t} = useTranslation();
    return useRoutes([
        {
            path: '/',
            //element: <HomePage t={t}/>
            element: <HomePageTest t={t}/>
        },
        /*{
            path: 'dashboard',
            element: <Dashboard/>
        },
        {
            path: 'surveys',
            element: <SurveyIndex/>
        },*/
        {
            path: 'surveys',
            element: <SurveySlackIndex/>
        },
        /*{
            path: 'collect/:id',
            element: <CollectIndex/>
        },
        {
            path: 'takeSurvey/:id',
            element: <TakeSurvey/>
        },*/
        {
            path: 'surveys-show/:id',
            element: <DisplaySurvey/>
        },
        /*
        {
            path: 'r/:id',
            element: <RespondSurvey/>
        },
        {
            path: 'r/sirq/:id',
            element: <RespondSignInRequired/>
        },*/
        {
            path: 'report/:id',
            element: <ResponsesReport/>
        },/*
        {
            path: 'myreport/:id',
            element: <MyReport/>
        },
        {
            path: 'reports',
            element: <ReportIndex/>
        },*/
        {
            path: 'charts/:id',
            //element: <ResponsesSurveyReport t={t} breakpoint={breakpoint}/>
            element: <ChartsMain/>,
            children: [
                {
                    index: true,
                    element: <ChartRedirect />
                },
                {
                    path: 'overview',
                    element: <Overview/>
                },
                {
                    path: 'questions-data',
                    element: <QuestionsData/>
                },
                {
                    path: 'comparative-information',
                    element: <ComparativeInformation/>
                }
            ]
        },
        {
            path: 'survey-create/*',
            element: <SurveyCreate/>
        },
        // {
        //     path: 'user-profile',
        //     element: <UserProfile/>
        // },
        /*{
            path: 'billing',
            element: <Billing/>
        },*/
        // {
        //     path: 'live-survey/:id/:userId',
        //     element: <ChatTest/>
        // },
        // {
        //     path: 'live-survey/:id',
        //     element: <ChatTest/>
        // },
        // {
        //     path: 'live-survey',
        //     element: <ChatTest/>
        // },
        {
            path: 'assignSubscriptions',
            element: <AssignUsers navigate={useNavigate()}/>
        }
    ]);
}

export default AppRouting;